import { render, staticRenderFns } from "./GunBoxes.vue?vue&type=template&id=374cbe02&"
import script from "./GunBoxes.vue?vue&type=script&lang=ts&"
export * from "./GunBoxes.vue?vue&type=script&lang=ts&"
import style0 from "./GunBoxes.vue?vue&type=style&index=0&id=374cbe02&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports